import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';
import brief from './brief';

const state = {
    briefsTareas: [],
    // briefsTareasTerceros: [],

    briefsTareasEstados: [],

    /* Filtro */
    cliente: null,
    presupuestoInterno: null,
    presupuestoNumero: 0,
    briefId: 0,
    prioridad: null,
    estado: null,
    estadoPendiente: true,
    incluirFinalizadas: false,
    // tareasTerceros: false,
    // usuario: null,
    sortByDescending: true,
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.briefsTareas = [];
        // state.briefsTareasTerceros = [];
        state.briefsTareasEstados = [];

        state.cliente = null;
        state.presupuestoInterno = null;
        state.presupuestoNumero = 0;
        state.briefId = 0;
        state.prioridad = null;
        state.estado = null;
        state.estadoPendiente = true;
        state.incluirFinalizadas = false;

        // state.tareasTerceros = false;
        // state.usuario = null;
     },
    'SET_BRIEFS_TAREAS_ESTADOS' (state, briefsTareasEstados) {
        state.briefsTareasEstados = briefsTareasEstados;
    },

    'INICIALIZAR_BRIEFS_TAREAS' (state) {
        state.briefsTareas = [];
        // state.briefsTareasTerceros = [];
    },
    'SET_BRIEFS_TAREAS' (state, briefsTareas) {
        state.briefsTareas = briefsTareas
            .sort((a, b) => {
                if (a.orden !== b.orden) {
                    return a.orden - b.orden;
                }
                return a.usuario.localeCompare(b.usuario);
            });

        state.briefsTareas.forEach(briefsTareasUsuario => {
            if (briefsTareasUsuario.tareas) {
                briefsTareasUsuario.tareas.forEach(tarea => {
                    tarea.briefTareaEstadoFontColor = getContrastingTextColor(tarea.briefTareaEstadoColor);
                    tarea._showDetails = false;
                });

                briefsTareasUsuario.tareas = briefsTareasUsuario.tareas.sort((a, b) => {
                    const fechaA = moment(a.fechaEntrega).format('YYYY-MM-DD') === '1900-01-01' ? Infinity : new Date(a.fechaEntrega);
                    const fechaB = moment(b.fechaEntrega).format('YYYY-MM-DD') === '1900-01-01' ? Infinity : new Date(b.fechaEntrega);
                    return fechaA - fechaB;
                });
            }
        });

        // state.briefsTareas = briefsTareas.map(tarea => ({
        //     ...tarea,
        //     briefTareaEstadoFontColor: getContrastingTextColor(tarea.briefTareaEstadoColor),
        //     _showDetails: false
        // })).sort((a, b) => {
        //     const fechaA = moment(a.fechaEntrega).format('YYYY-MM-DD') === '1900-01-01' ? Infinity : new Date(a.fechaEntrega);
        //     const fechaB = moment(b.fechaEntrega).format('YYYY-MM-DD') === '1900-01-01' ? Infinity : new Date(b.fechaEntrega);
        //     return fechaA - fechaB;
        // });
    },
    'SET_BRIEFS_TAREAS_TERCEROS' (state, briefsTareas) {
        state.briefsTareasTerceros = briefsTareas.map(tarea => ({
            ...tarea,
            briefTareaEstadoFontColor: getContrastingTextColor(tarea.briefTareaEstadoColor),
            _showDetails: false
        })).sort((a, b) => {
            const fechaA = moment(a.fechaEntrega).format('YYYY-MM-DD') === '1900-01-01' ? Infinity : new Date(a.fechaEntrega);
            const fechaB = moment(b.fechaEntrega).format('YYYY-MM-DD') === '1900-01-01' ? Infinity : new Date(b.fechaEntrega);
            return fechaA - fechaB;
        });
    },
    'SET_BRIEF_TAREA'(state, params) {
        let estadoColor = '#ff0000';
        let briefTareaEstado = state.briefsTareasEstados.find(t => t.id == params.briefTarea.briefTareaEstadoId);
        if (briefTareaEstado) {
            estadoColor = briefTareaEstado.color;
        }

        let tarea;

        let briefTareasUsuario = state.briefsTareas.find(t => t.usuarioId == params.usuarioId);

        if (briefTareasUsuario) {
            tarea = briefTareasUsuario.tareas.find(t => t.id == params.briefTarea.id);
        }

        // let tarea = state.briefsTareas.find(t => t.id == briefTarea.id);

        if (tarea) {
            tarea.fechaEntrega = params.briefTarea.fechaEntrega;
            tarea.titulo = params.briefTarea.titulo;
            tarea.descripcion = params.briefTarea.descripcion;
            tarea.prioridadId = params.briefTarea.prioridadId;
            tarea.prioridad = params.briefTarea.prioridad? params.briefTarea.prioridad.nombre.trim() : null;
            tarea.briefTareaEstadoId = params.briefTarea.briefTareaEstadoId;
            tarea.briefTareaEstado = params.briefTarea.briefTareaEstado? params.briefTarea.briefTareaEstado.nombre.trim() : null;
            tarea.briefTareaEstadoColor = estadoColor;
            tarea.briefTareaEstadoFontColor = getContrastingTextColor(estadoColor);
            tarea.usuarioId = params.briefTarea.usuarioId;
            tarea.usuarioIniciales = params.briefTarea.usuario? params.briefTarea.usuario.nombre.trim() : null;
            tarea.usuario = params.briefTarea.usuario? params.briefTarea.usuario.nombre.trim() : null;

            /* Actualizamos la lista de usuarios si se modificó el usuario asignado */
            if (params.briefTarea.usuarioId != params.usuarioId) {
                let itemKey = briefTareasUsuario.tareas
                    .findIndex(t => t.id == params.briefTarea.id);

                if (itemKey != -1) {
                    /* Buscamos el dashboard del usuario asignado */
                    let briefTareasUsuarioActualizado = state.briefsTareas.find(t => t.usuarioId == params.briefTarea.usuarioId);
                    
                    if (briefTareasUsuarioActualizado) {
                        /* Agregamos la tarea */
                        briefTareasUsuarioActualizado.tareas.push(tarea);

                        /* Ordenamos la lista de tareas */
                        briefTareasUsuarioActualizado.tareas = briefTareasUsuarioActualizado.tareas
                            .sort((a, b) => {
                                const fechaA = moment(a.fechaEntrega).format('YYYY-MM-DD') === '1900-01-01' ? Infinity : new Date(a.fechaEntrega);
                                const fechaB = moment(b.fechaEntrega).format('YYYY-MM-DD') === '1900-01-01' ? Infinity : new Date(b.fechaEntrega);
                                return fechaA - fechaB;
                            });
                        
                    } else {
                        /* Agregamos el usuario al dashboard */
                        state.briefsTareas.push({
                            usuarioId: params.briefTarea.usuarioId,
                            usuario: params.briefTarea.usuario? params.briefTarea.usuario.nombre.trim() : null,
                            tareas: [tarea],
                            orden: params.briefTarea.usuarioId == params.currentUserId ? 1 : (params.briefTarea.usuarioId == 0 ? 3 : 2)
                        });

                        state.briefsTareas = state.briefsTareas
                            .sort((a, b) => {
                                if (a.orden !== b.orden) {
                                    return a.orden - b.orden;
                                }
                                return a.usuario.localeCompare(b.usuario);
                            });
                    }

                    /* Quitamos la tarea de la lista original */
                    briefTareasUsuario.tareas.splice(itemKey, 1);

                    /* Si no tiene tareas, elimino el usuario del dashboard */
                    if (briefTareasUsuario.tareas.length == 0) {
                        state.briefsTareas.splice(state.briefsTareas.indexOf(briefTareasUsuario), 1);
                    }
                }
            } else {
                /* Ordenamos la lista de tareas */
                briefTareasUsuario.tareas = briefTareasUsuario.tareas
                    .sort((a, b) => {
                        const fechaA = moment(a.fechaEntrega).format('YYYY-MM-DD') === '1900-01-01' ? Infinity : new Date(a.fechaEntrega);
                        const fechaB = moment(b.fechaEntrega).format('YYYY-MM-DD') === '1900-01-01' ? Infinity : new Date(b.fechaEntrega);
                        return fechaA - fechaB;
                    });
            }
        }    

        // state.briefsTareas = state.briefsTareas
        //     .sort((a, b) => {
        //         const fechaA = moment(a.fechaEntrega).format('YYYY-MM-DD') === '1900-01-01' ? Infinity : new Date(a.fechaEntrega);
        //         const fechaB = moment(b.fechaEntrega).format('YYYY-MM-DD') === '1900-01-01' ? Infinity : new Date(b.fechaEntrega);
        //         return fechaA - fechaB;
        //     });
    },
    'DELETE_BRIEF_TAREA'(state, briefTareaId) {
        let itemKey = state.briefTareas
            .findIndex(t => t.id == briefTareaId);

        if (itemKey != -1) {
            state.briefTareas.splice(itemKey, 1);
        }
    },
    'SHOW_DETAILS_BRIEF_TAREA'(state, params) {
        let tarea;

        let briefTareasUsuario = state.briefsTareas.find(t => t.usuarioId == params.usuarioId);

        if (briefTareasUsuario) {
            tarea = briefTareasUsuario.tareas.find(t => t.id == params.briefTareaId);
        }

        // let tarea = state.briefsTareas.find(t => t.id == briefTareaId);

        if (tarea) {
            tarea._showDetails = !tarea._showDetails;
        }
    },
    'UPDATE_ESTADO'(state, params) {
        let briefTarea;

        let briefTareasUsuario = state.briefsTareas.find(t => t.usuarioId == params.usuarioId);

        if (briefTareasUsuario) {
            briefTarea = briefTareasUsuario.tareas.find(t => t.id == params.briefTareaId);
        }

        // let briefTarea = state.briefsTareas.find(t => t.id == params.briefTareaId);

        let estadoColor = '#ff0000';
        let briefTareaEstado = state.briefsTareasEstados.find(t => t.id == params.briefTareaEstadoId);
        if (briefTareaEstado) {
            estadoColor = briefTareaEstado.color;
        }

        if (briefTarea) {
            briefTarea.briefTareaEstadoId = params.briefTareaEstadoId;
            briefTarea.briefTareaEstado = params.briefTareaEstado? params.briefTareaEstado.nombre.trim() : null;
            briefTarea.briefTareaEstadoColor = estadoColor;
            briefTarea.briefTareaEstadoFontColor = getContrastingTextColor(estadoColor);
        }
    },
    'UPDATE_PRIORIDAD'(state, params) {
        let briefTarea;

        let briefTareasUsuario = state.briefsTareas.find(t => t.usuarioId == params.usuarioId);

        if (briefTareasUsuario) {
            briefTarea = briefTareasUsuario.tareas.find(t => t.id == params.briefTareaId);
        }

        // let briefTarea = state.briefsTareas.find(t => t.id == params.briefTareaId);

        if (briefTarea) {
            briefTarea.prioridadId = params.prioridadId;
            briefTarea.prioridad = params.prioridad? params.prioridad.nombre.trim() : null;
        }
    },
    'UPDATE_FECHA_ENTREGA'(state, params) {
        let briefTarea;

        let briefTareasUsuario = state.briefsTareas.find(t => t.usuarioId == params.usuarioId);

        if (briefTareasUsuario) {
            briefTarea = briefTareasUsuario.tareas.find(t => t.id == params.briefTareaId);
        }

        // let briefTarea = state.briefsTareas.find(t => t.id == params.briefTareaId);

        if (briefTarea) {
            briefTarea.fechaEntrega = params.fechaEntrega;
        }
    },    
};

// function getDatosBriefs(briefs) {
//     let briefsTareas = [];

//     briefs.forEach(brief => {
//         briefsTareas.push(getDatosBrief(brief));
//     });

//     return briefsTareas;
// }

// function getDatosBrief(brief) {
//     let tareas = [];

//     if (brief.tareas) {
//         tareas = brief.tareas
//             .map(tarea => ({
//                 ...tarea,
//                 briefTareaEstadoFontColor: getContrastingTextColor(tarea.briefTareaEstadoColor),
//                 _showDetails: false
//             })).sort((a, b) => new Date(a.fechaEntrega) - new Date(b.fechaEntrega)) || [];
//     }

//     return {
//         ...brief,
//         showBrief: false,
//         tareas
//     };
// }

function getContrastingTextColor(hexColor) {
    // Quita el símbolo # si está
    hexColor = hexColor.replace('#', '');

    // Parsea los valores R, G y B
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);

    // Calcula la luminancia
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

    // Retorna negro o blanco según la luminancia
    return luminance > 140 ? '#23282c' : '#FFFFFF';
}

const getters = {
    getField,
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getBriefsTareas ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BRIEFS_TAREAS');

            let queryString = '';

            if (state.cliente) {
                if (state.cliente.id != 0) {
                    queryString += (queryString == '' ? '?' : '&') + 'clienteId=' + state.cliente.id;
                }
            }
            if (state.presupuestoInterno) {
                if (state.presupuestoInterno.id != 0) {
                    queryString += (queryString == '' ? '?' : '&') + 'presupuestoInternoId=' + state.presupuestoInterno.id;
                }
            }
            if (state.presupuestoNumero != 0) {
                queryString += (queryString == '' ? '?' : '&') + 'presupuestoNumero=' + state.presupuestoNumero;
            }
            if (state.briefId != 0) {
                queryString += (queryString == '' ? '?' : '&') + 'briefId=' + state.briefId;
            }
            if (state.prioridad) {
                if (state.prioridad.id != 0) {
                    queryString += (queryString == '' ? '?' : '&') + 'prioridadId=' + state.prioridad.id;
                }
            }
            if (state.estado) {
                if (state.estado.id != 0) {
                    queryString += (queryString == '' ? '?' : '&') + 'estadoId=' + state.estado.id;
                }
            }
            if ((/true/i).test(state.estadoPendiente)) {
                queryString += (queryString == '' ? '?' : '&') + 'estadoPendiente=true';
            }
            if ((/true/i).test(state.incluirFinalizadas)) {
                queryString += (queryString == '' ? '?' : '&') + 'incluirFinalizadas=true';
            }

            if ((/true/i).test(state.tareasTerceros)) {
                /* Recuperamos el dashboard propio y luego el de terceros */
                apiAxios.get(`briefs/tareas/estados/list`)
                    .then(res => {
                        commit('SET_BRIEFS_TAREAS_ESTADOS', res.data);
                        
                        return apiAxios.get('briefs/tareas' + queryString);
                    })
                    .then(res => {
                        commit('SET_BRIEFS_TAREAS', res.data);
                        
                        resolve();

                        // /* Briefs/Tareas de terceros */
                        // queryString += (queryString == '' ? '?' : '&') + 'tareasTerceros=true';
                        
                        // if (state.usuario) {
                        //     if (state.usuario.id != 0) {
                        //         queryString += (queryString == '' ? '?' : '&') + 'usuarioId=' + state.usuario.id;
                        //     }
                        // }

                        // return apiAxios.get('briefs/tareas' + queryString);
                    })
                    // .then(res => {
                    //     commit('SET_BRIEFS_TAREAS_TERCEROS', res.data);
                    //     resolve();
                    // })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));

            } else {
                /* Recuperamos únicamente el dashboard propio */
                apiAxios.get(`briefs/tareas/estados/list`)
                    .then(res => {
                        commit('SET_BRIEFS_TAREAS_ESTADOS', res.data);

                        return apiAxios.get('briefs/tareas/dashboard' + queryString);
                    })
                    .then(res => {
                        commit('SET_BRIEFS_TAREAS', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })
    },
    setBriefTarea ( { commit, rootState }, params ) {
        return new Promise((resolve, reject) => {
            params.currentUserId = 0;
            if (rootState.user) {
                if (rootState.user.userId) {
                    params.currentUserId = rootState.user.userId;
                }
            }

            commit('SET_BRIEF_TAREA', params);
            resolve();
        }, error => {
            reject(error);
        });
    },
    updatePrioridad ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            let briefTareaActualizacion= {
                prioridadId: parseInt(params.prioridadId)
            }

            apiAxios.post(`briefs/tareas/${params.briefTareaId}/prioridad`, briefTareaActualizacion)
                .then(() => {
                    commit('UPDATE_PRIORIDAD', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    updateEstado ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            let briefTareaActualizacion= {
                briefTareaEstadoId: parseInt(params.briefTareaEstadoId)
            }

            apiAxios.post(`briefs/tareas/${params.briefTareaId}/estado`, briefTareaActualizacion)
                .then(() => {
                    commit('UPDATE_ESTADO', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    updateFechaEntrega ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            let briefTareaActualizacion= {
                fechaEntrega: moment(params.fechaEntrega).format('YYYY-MM-DD')
            }

            apiAxios.post(`briefs/tareas/${params.briefTareaId}/fecha-entrega`, briefTareaActualizacion)
                .then(() => {
                    commit('UPDATE_FECHA_ENTREGA', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    updateUsuario ( {}, params ) {
        return new Promise((resolve, reject) => {
            let briefTareaActualizacion= {
                usuarioId: parseInt(params.usuarioId)
            }

            apiAxios.post(`briefs/tareas/${params.briefTareaId}/usuario`, briefTareaActualizacion)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    delete ( { commit }, briefTareaId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`briefs/tareas/${briefTareaId}/delete`)
                .then(() => {
                    commit('DELETE_BRIEF_TAREA', briefTareaId);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    showDetailsTarea ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('SHOW_DETAILS_BRIEF_TAREA', params);
            resolve();
        })
    },        
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}